import React from 'react'
import { render } from 'react-dom'
import { App } from './App'

import 'antd/dist/antd.css'

// const {zip} = require('zip-js/WebContent/zip.js')
// zip.workerScriptsPath = './node_modules/zip-js/WebContent/'
// require('zip-js/WebContent/z-worker.js')
// require('zip-js/WebContent/deflate.js')
// require('zip-js/WebContent/inflate.js')
// window.zip = zip

function renderApp() {
  render(<App />, root)
}

renderApp()

module.hot.accept()
